/* Farbvergleich
 * - Klick auf eine Auswahlflaeche tauscht nur das Bild, ohne Blende
 * - mobil: waagerechter Slider mit mitlaufenden Punkten
 */
(function () {
  'use strict';

  if (!customElements.get('old-color-comparison')) {
    class OldColorComparison extends HTMLElement {
      connectedCallback() {
        if (this.dataset.vccReady) return;
        this.dataset.vccReady = '1';

        this.addEventListener('click', function (event) {
          var button = event.target.closest('[data-vcc-option]');
          if (!button || button.classList.contains('is-active')) return;

          var index = button.dataset.vccOption;

          this.querySelectorAll('[data-vcc-option]').forEach(function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });

          this.querySelectorAll('[data-vcc-slide]').forEach(function (slide) {
            slide.classList.toggle('is-active', slide.dataset.vccSlide === index);
          });
        });
      }
    }

    customElements.define('old-color-comparison', OldColorComparison);
  }

  /* ---------- Slider-Punkte ---------- */

  function initSlider(viewport) {
    if (viewport.dataset.vccSlider) return;
    viewport.dataset.vccSlider = '1';

    var section = viewport.closest('.vcc');
    if (!section) return;

    var dots = section.querySelectorAll('[data-vcc-dot]');
    var cards = viewport.querySelectorAll('.vcc__card');
    if (!dots.length || !cards.length) return;

    var ticking = false;

    viewport.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var center = viewport.scrollLeft + viewport.clientWidth / 2;
        var index = 0;
        var best = Infinity;

        cards.forEach(function (card, i) {
          var mid = card.offsetLeft + card.offsetWidth / 2;
          var distance = Math.abs(mid - center);
          if (distance < best) {
            best = distance;
            index = i;
          }
        });

        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      });
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var card = cards[i];
        if (!card) return;
        viewport.scrollTo({
          left: card.offsetLeft - (viewport.clientWidth - card.offsetWidth) / 2,
          behavior: 'smooth'
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-vcc-viewport]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();